import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePostHog } from 'posthog-js/react';
import { useAuth } from '../providers';

const Callback = () => {
  const auth = useAuth();
  const navigate = useNavigate();
  const posthog = usePostHog();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const { idTokenPayload } = await auth.parseHash();

        const posthogUserId = posthog.get_distinct_id();

        if (posthogUserId !== idTokenPayload.sub) {
          posthog.identify(idTokenPayload.sub, {
            email: idTokenPayload.email,
            name: idTokenPayload.name,
            picture: idTokenPayload.picture
          });
        }

        navigate('/');
      } catch (err) {
        navigate(`/auth/login?error=${err.error}&reason=${err.errorDescription}`);
      }
    };
    handleCallback();
  }, [navigate, posthog]);

  return null;
};

export { Callback };
